import { defineMessages } from 'react-intl';

export const messages: {
	eventLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	eventLabel: {
		id: 'search-graph-data-table.data-table-label',
		defaultMessage: 'Data table',
		description:
			'Badge label shown on a data table search result card to identify the result type as a data table.',
	},
});
